<template>
	<sf-content-layout class="p-0">
		<template v-slot:content>
			<div class="h-100" style="overflow-y: auto">
				<widget-content :scrId="scrId" />
				<widget-sidebar v-show="widgetSideBar" :scrId="scrId" />
			</div>
		</template>
	</sf-content-layout>
</template>
<script>
import WidgetContent from './Content/Content.vue';
import WidgetSidebar from './Content/WidgetSidebar/WidgetSidebar.vue';
import { serviceComputed, serviceMethods } from './store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { WidgetContent, WidgetSidebar },
	//TODO: 온사이트 용 확인 필요
	// created() {
	// 	// document.body.setAttribute('data-theme', 'brand');
	// 	document.body.setAttribute('data-theme', this.user.topSkin);
	// },
	data() {
		return {
			showModal: false
		};
	},
	methods: {
		...serviceMethods
	},
	computed: {
		...serviceComputed
	}
};
</script>

<style></style>
